import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setSelectedPackage, reportDWH } from '../../EnergyReplaceBlockSlice';
import { getEnergyReplacePricesAsync } from '../../EnergyReplaceBlockAsyncThunk';
import SalePackages from '../../../SalePackagesBlock/SalePackages';
import Tooltip from '../../../../Shared/Tooltip/Tooltip';
import infoIcon from './images/info-icon.svg';

const PackagesPage = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='energy-packages-page'>

            <div className='page-content'>

                <div className='my-package-wrapper'>
                    <div className='my-package-title'> התוכנית שלי </div>
                    <div className='my-package-info'>
                        <a href='#' className='info-link' id={'tooltip-info'} onClick={(e) => e.preventDefault()} style={{backgroundImage:infoIcon.bg()}}></a>
                        <Tooltip text={getTooltipText(props.subscriber)} target={'tooltip-info'} placement={'bottom'} cellcomdefault={true} />
                        <span className='package-name'> {props.subscriber?.socBillDescription} </span>
                        <span className='package-separator'> | </span>
                        <span className='package-info'> מספר מונה: {props.equipment?.productId} </span>
                    </div>
                </div>

                <div className='page-title'> לאיזו תכנית להעביר את המנוי? </div>
            </div>

            <div className='packages-wrapper'>
                <SalePackages packages={props.salePackages} onSelectedPackages={onSelectedPackages} />
            </div>
        </div>
    );

    function onSelectedPackages(salePackage) {
        props.setSelectedPackage(salePackage);
        props.reportDWH({
          actionType: 'SelectPlan',
          status:'Ongoing',
          messageText: 'PlanSelectionDisplay'
        });
        props.getEnergyReplacePricesAsync();
    }

    function getTooltipText(item) {
        const htmlString = `
            <div class='package-info-tooltip'>
                <div> ${item.socBillDescription} </div>
                ${item.planDetails ? `<div class='tooltip-bold-text'> ${item.planDetails} </div>` : ''}
            </div>
        `;
        return htmlString;
    }

};

const mapStateToProps = (state) => {
    return {
        page: state.energyReplaceBlock.page,
        salePackages: state.energyReplaceBlock.salePackages,
        subscriber: state.energyReplaceBlock.subscriber,
        equipment: state.energyReplaceBlock.subscriber?.equipments?.find(x=> x.productSaleType == 'Energy')
    };
};

const mapDispatchToProps = {
    getEnergyReplacePricesAsync,
    setSelectedPackage,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PackagesPage);
